import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { AccordionFragment } from '@app-graphql/schema'

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AccordionComponent {

    @Input()
    public accordion: AccordionFragment

}
